<template>
  <div
    v-loading.fullscreen.lock="fullscreenLoading"
    class="verify-box"
    style="width: 400px"
  >
    <el-dialog
      title="拆工单理赔"
      :visible="true"
      :before-close="onCloseDialog"
      :width="380"
    >
      <el-form style="margin-left: 10%">
        <el-form-item label="工单id：">
          {{ resData.work_id }}
        </el-form-item>
        <el-form-item label="无实物拆包数量：">
          {{ resData.no_back_num }}
        </el-form-item>
        <el-form-item label="拆分件数：">
          <el-input
            v-model="form.num"
            type="number"
            placeholder="输入拆分件数"
            size="mini"
            style="width: 400px"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button @click="onCloseDialog">取 消</el-button>
          <el-button type="primary" @click="submitData">确 定</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: {
    claims_detail_id: {
      default: [],
    },
    origin: {},
  },
  data() {
    return {
      form: {},
      types: [],
      resData: {},
      loading: false,
      num: 0,
      data: [],
      fullscreenLoading: false,
      url: "/erp/Claims/beforeSplit",
    };
  },
  mounted() {
    this.fetchData();
  },
  methods: {
    fetchData() {
      if (!this.claims_detail_id) {
        return this.$message.error("数据不存在");
      }
      this.form.claims_detail_id = this.claims_detail_id;
      this.fullscreenLoading = true;
      this.$http
        .post(this.url, this.form)
        .then(result => {
          this.fullscreenLoading = false;
          if (result.data.code != 200) {
            // this.onCloseDialog();
            return this.$message.error(result.data.msg);
          }
          this.$set(this, "resData", result.data.data);
        })
        .catch(err => {
          this.onCloseDialog();
          return this.$message.error("数据获取失败");
        });
    },
    submitData() {
      this.fullscreenLoading = true;
      this.$http
        .post("/erp/claims/split", this.form)
        .then(result => {
          this.fullscreenLoading = false;
          if (result.data.code != 200) {
            return this.$message.error(result.data.msg);
          } else {
            this.onCloseDialog();
            return this.$message.success(result.data.msg);
          }
        })
        .catch(err => {
          return this.$message.error("数据获取失败");
        });
    },
    onCloseDialog() {
      this.$emit("onCloseDialog", false);
    },
    resetData() {},
  },
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/pages/claims/components/Split.vue